import React from 'react';
import { PlusOutlined, LinkOutlined } from '@ant-design/icons';
import { Button, Table, Divider, Modal, Form, Input, Alert } from 'antd';
import { Api } from '../../../lib/api';

import '../styles.scss';
import { SUBSCRIBERS } from '../components/pageNameConstants';
import DeleteWarningModal from '../components/DeleteWarningModal';

export default class Subscribers extends React.PureComponent {
    state = {
        subscribers: [],
        loading: true,
        createVisible: false,
        editVisible: false,
        url: '',
        id: null,
        showDeleteModal: false,
        currentRecordName: null,
        currentRecordId: null
    };

    componentDidMount() {
        this.getSubscribers();
    }

    getSubscribers = async () => {
        await Api.getSubscribers().then((subscribers) => {
            this.setState({ subscribers: subscribers, loading: false, createVisible: false, editVisible: false });
        });
    }

    deleteSubscribers = (id) => {
        return Api.deleteSubscriber(id);
    }
    
    validateSubscriber(subscriber) {
        if(subscriber !== undefined) {
            this.getSubscribers();
        } else {
            alert('Not a valid URL');
        }
    }
    register = async (values) => {
        if (this.state.createVisible) {
            if (this.state.subscribers.length >= 10) {
                alert('The maximum number of subscribers is 10 ');
            } else {
                await Api.createSubscriber(values.url).then(subscriber => {
                    this.validateSubscriber(subscriber);
                });
            }
        }
        if (this.state.editVisible) {
            await Api.updateSubscriber(this.state.id, values.url).then(subscriber => {
                this.validateSubscriber(subscriber);
            });
        }
    };
    closeDeleteModal = () => {
        this.setState({showDeleteModal: false});
    }
    render() {
        return (
            <div className="section page-card">
                <div className="create-button">
                    <Button
                        type="primary"
                        shape="round"
                        icon={<PlusOutlined />}
                        onClick={() => this.setState({ createVisible: true, url: '' })}
                    >
                        New Subscriber
                    </Button>
                </div>

                <Modal
                    title="New Subscriber"
                    open={this.state.createVisible}
                    onCancel={() => {
                        this.setState({ createVisible: false });
                        // document.getElementById('create-password').reset();
                    }}
                    footer={null}
                >
                    <Alert
                        className="alert"
                        showIcon={true}
                        message={<div>Example : http://192.168.12.99:8555 </div>}
                        banner
                    />
                    <Form
                        name="register"
                        onFinish={this.register}
                        className="login-form"
                        id="create-password"
                        initialValues={this.state}
                    >
                        <Form.Item
                            name="url"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your username'
                                }
                            ]}
                        >
                            <Input prefix={<LinkOutlined className="site-form-item-icon" />} placeholder="End Point" />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" className="login-form-button">
                                Add Subscriber
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
                {this.state.editVisible && (
                    <Modal
                        title="Edit Subscriber"
                        open={this.state.editVisible}
                        onCancel={() => {
                            this.setState({ editVisible: false, url: '' });
                            // document.getElementById('create-password').reset();
                        }}
                        footer={null}
                    >
                        <Alert
                            className="alert"
                            showIcon={true}
                            message={<div>Example : http://192.168.12.99:8555 </div>}
                            banner
                        />
                        <Form
                            name="register"
                            onFinish={this.register}
                            className="login-form"
                            id="create-password"
                            initialValues={this.state}
                        >
                            <Form.Item
                                name="url"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your url'
                                    }
                                ]}
                            >
                                <Input prefix={<LinkOutlined className="site-form-item-icon" />} placeholder="End Point" />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="login-form-button">
                                    Update Subscriber
                                </Button>
                            </Form.Item>
                        </Form>
                    </Modal>
                )}
                <Table
                    columns={[
                        {
                            title: 'Subscriber',
                            dataIndex: 'url',
                            key: 'username',
                            render: (text, record) => <div>{text}</div>
                        },
                        {
                            title: 'Action',
                            key: 'action',
                            render: (text, record) => (
                                <div className="action-buttons">
                                    <Button
                                        type="link"
                                        style={{ color: '#40a9ff' }}
                                        onClick={() => this.setState({ url: record.url, editVisible: true, id: record.id })}
                                    >
                                        Edit
                                    </Button>
                                    <Divider type="vertical" />
                                    <Button
                                        type="link"
                                        style={{ color: '#e60013' }}
                                        onClick={() => {
                                            this.setState({
                                                showDeleteModal: true,
                                                currentRecordId: record.id,
                                                currentRecordName: record.url
                                            })
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            )
                        }
                    ]}
                    dataSource={this.state.subscribers}
                    pagination={{ pageSize: 8 }}
                    rowKey="id"
                />
                <DeleteWarningModal
                    isOpen={this.state.showDeleteModal}
                    itemTypeToDelete={SUBSCRIBERS}
                    itemNameToDelete={this.state.currentRecordName}
                    itemRecordToDelete={this.state.currentRecordId}
                    closeCallback={this.closeDeleteModal}
                    update={this.getSubscribers}
                    delete={this.deleteSubscribers}
                    >
                </DeleteWarningModal>
            </div>
        );
    }
}
